<ion-header class="ion-no-border">
  <ion-toolbar noUnderline>
    @if (forced === false && osSupported === true) {
      <ion-buttons slot="end">
        <ion-button fill="clear" class="secondaryTextLink" type="button" (click)="onDismiss()">SKIP </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  @if (osSupported === true) {
    <div class="supported">
      <ion-grid>
        <ion-row class="image-row">
          <img src="/assets/imgs/update-os-supported.svg" />
        </ion-row>
        <ion-row>
          <ion-col>
            <h2 [ngClass]="{ forced: forced }">{{ forced ? 'App update required' : 'App update available now!' }}</h2>
            @if (forced) {
              <h3>Please update Parent Hub before continuing.</h3>
            }
            <hr />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <span class="whats-new">What's new?</span>
            <div [innerHTML]="latestRelease.notes"></div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  }
  @if (osSupported === false) {
    <div class="not-supported">
      <ion-grid>
        <ion-row class="image-row">
          <img src="/assets/imgs/update-os-not-supported.svg" />
        </ion-row>
        <ion-row>
          <ion-col>
            <h2 class="forced">New app requires device<br />system update</h2>
            @if (forced === false) {
              <h3>
                To enjoy the latest version of Parent Hub, please update your device's operating system.
              </h3>
            }
            @if (forced === true) {
              <h3>To keep using Parent Hub, please update your device's operating system.</h3>
            }
            <hr />
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <span class="whats-new">What's new?</span>
            <div [innerHTML]="latestRelease.notes"></div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  }
  <div class="versions">
    <ion-grid>
      <ion-row>
        <ion-col>
          <span>Current version: {{ appCurrentVersion }}</span>
          <span>Latest version: {{ latestRelease.appVersion }}</span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
@if (osSupported === true) {
  <ion-footer mode="ios">
    <ion-button mode="md" (click)="onUpdate()" class="submitButton" color="secondary">Update now</ion-button>
  </ion-footer>
}
@if (forced === false && osSupported === false) {
  <ion-footer mode="ios">
    <ion-button mode="md" (click)="onDismiss()" class="submitButton" color="secondary">OK</ion-button>
  </ion-footer>
}
